//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../no/View.js";
let d=[[[0,"FogBackValue",1,0],[0,"FogBackgroundColor",1,0],[0,"FogColorHLSValue",1,0],[0,"FogColorHSVValue",1,0],[0,"FogColorRGBValue",1,0],[0,"FogFrontValue",1,0],[0,"FogRateValue",1,0],[0,"FogSetting",1,0],[0,"FogSettingOption",1,0]],[[["fog_data"],"UpdateFogDisplay",{},1,0]],[]];
SPLM.Preferences.ViewVisualizationSpecialEffects = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.ViewVisualizationSpecialEffects";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Preferences.ViewVisualizationSpecialEffects.ColorRGB = class{
    constructor(red_color,green_color,blue_color){
        this.red_color=red_color;this.green_color=green_color;this.blue_color=blue_color;}
    get RedColor(){return this.red_color}
    set RedColor(val){this.red_color = val}
    get GreenColor(){return this.green_color}
    set GreenColor(val){this.green_color = val}
    get BlueColor(){return this.blue_color}
    set BlueColor(val){this.blue_color = val}
};

SPLM.Preferences.ViewVisualizationSpecialEffects.FogData = class{
    constructor(fog_mode,fog_color_flag,fog_color,fog_start,fog_end,fog_density){
        this.fog_mode=fog_mode;this.fog_color_flag=fog_color_flag;this.fog_color=fog_color;this.fog_start=fog_start;this.fog_end=fog_end;this.fog_density=fog_density;}
    get FogMode(){return this.fog_mode}
    set FogMode(val){this.fog_mode = val}
    get FogColorFlag(){return this.fog_color_flag}
    set FogColorFlag(val){this.fog_color_flag = val}
    get FogColor(){if(this.fog_color === undefined) this.fog_color = new SPLM.Preferences.ViewVisualizationSpecialEffects.ColorRGB(); return this.fog_color}
    set FogColor(val){this.fog_color = val}
    get FogStart(){return this.fog_start}
    set FogStart(val){this.fog_start = val}
    get FogEnd(){return this.fog_end}
    set FogEnd(val){this.fog_end = val}
    get FogDensity(){return this.fog_density}
    set FogDensity(val){this.fog_density = val}
};

SPLM.Preferences.ViewVisualizationSpecialEffects.ColorHSV = class{
    constructor(hue,saturation,value){
        this.hue=hue;this.saturation=saturation;this.value=value;}
    get Hue(){return this.hue}
    set Hue(val){this.hue = val}
    get Saturation(){return this.saturation}
    set Saturation(val){this.saturation = val}
    get Value(){return this.value}
    set Value(val){this.value = val}
};

SPLM.Preferences.ViewVisualizationSpecialEffects.ColorHLS = class{
    constructor(hue,lightness,saturation){
        this.hue=hue;this.lightness=lightness;this.saturation=saturation;}
    get Hue(){return this.hue}
    set Hue(val){this.hue = val}
    get Lightness(){return this.lightness}
    set Lightness(val){this.lightness = val}
    get Saturation(){return this.saturation}
    set Saturation(val){this.saturation = val}
};

SPLM.Preferences.ViewVisualizationSpecialEffects.FogType = Object.freeze({
    "Linear" : "Linear", "Light" : "Light", "Heavy" : "Heavy"});

export default SPLM;